import { useContext } from 'react';
import { StateYearContext } from '@/contexts/state-year-context';

export function useStateYear() {
  const context = useContext(StateYearContext);
  if (context === undefined) {
    throw new Error('useStateYear must be used within a StateYearProvider');
  }
  return context;
}
